"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_ACCOUNT_ERROR_CODES = void 0;
var SEARCH_ACCOUNT_ERROR_CODES = exports.SEARCH_ACCOUNT_ERROR_CODES = function (SEARCH_ACCOUNT_ERROR_CODES) {
  SEARCH_ACCOUNT_ERROR_CODES[SEARCH_ACCOUNT_ERROR_CODES["TOO_MANY_RESULTS"] = 413] = "TOO_MANY_RESULTS";
  return SEARCH_ACCOUNT_ERROR_CODES;
}({});